module.exports = __webpack_public_path__ + "img/2015061.bdf8a752.svg";